import { required, url, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

/**
 * @param {object} formState  ฟอร์มของสาขา
 * @param {object} shopTax    ค่าภาษีระดับร้าน (อ่านอย่างเดียว) — ตั้งที่หน้าตั้งค่าร้าน
 *                            ใช้ตัดสินว่าสาขาต้องกรอกรหัสสถานประกอบการไหม
 */
export default function (formState, shopTax = {}) {
  const isVatRegistered = () => !!shopTax.tax_policy && shopTax.tax_policy !== 'no_tax';

  return {
    form: {
      logo: {
      },
      telephone1: {
      },
      address: {},
      postal_code: {},
      sub_district: {},
      district: {},
      province: {},
      branch_no: {
        required: helpers.withMessage(
          i18n.global.t('Please enter a branch number.'),
          requiredIf(isVatRegistered)
        ),
        format: helpers.withMessage(
          i18n.global.t('Branch number must be 5 digits.'),
          (value) => !helpers.req(value) || /^\d{5}$/.test(value)
        ),
      },
      service_charge_rate: {
      },
      receipt_header: {
      },
      receipt_footer: {
      },
      review_url: {
        required: helpers.withMessage(
          i18n.global.t('Please enter the review URL.'),
          requiredIf(() => formState.show_qrcode_review === true)
        ),
        url: helpers.withMessage(
          i18n.global.t('Please enter a valid URL.'),
          (value) => !helpers.req(value) || url.$validator(value)
        ),
      },
      show_logo: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_tax_id: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_receipt_header: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_receipt_footer: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_branch_name: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_branch_address: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_branch_phone: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_table_number: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_customer_info: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_qrcode_promptpay: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_qrcode_review: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_item_note: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
      show_bill_number: { required: helpers.withMessage(i18n.global.t('Please enter.'), required) },
    }
  }
};
